// Analytics containers
export const ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG = 'twoStepInstallDialog';

// Analytics subject ids
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_CLOSE_BUTTON = 'twoStepInstallDialogCloseButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_BACK_BUTTON = 'twoStepInstallDialogBackButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_SITE_SELECTOR = 'twoStepInstallDialogSiteSelector';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_FOCUSED_TASK = 'twoStepInstallFocusedTask';

// Main CTA buttons
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_REQUEST_APP_BUTTON = 'twoStepInstallDialogRequestAppButton';

// Installation CTA buttons
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_GET_IT_NOW_BUTTON = 'twoStepInstallGetItNowButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_START_FREE_TRIAL_BUTTON = 'twoStepInstallStartFreeTrialButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_ADD_TO_SANDBOX_BUTTON = 'twoStepInstallAddToSandboxButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_ACTIVATE_TRIAL_BUTTON = 'twoStepInstallActivateTrialButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_ADD_APP_BUTTON = 'twoStepInstallAddAppButton';

// App management CTA buttons
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_REVIEW_APP_BUTTON = 'twoStepInstallDialogReviewAppButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_GET_STARTED_BUTTON = 'twoStepInstallDialogGetStartedButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_CONFIGURE_APP_BUTTON = 'twoStepInstallDialogConfigureAppButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_MANAGE_APP_BUTTON = 'twoStepInstallDialogManageAppButton';

// Editions CTA buttons.
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_TRY_ADVANCED_APP_BUTTON = 'twoStepInstallDialogTryAdvancedAppButton';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_TRY_STANDARD_APP_BUTTON = 'twoStepInstallDialogTryStandardAppButton';

// Accordion subject ids
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_SCOPES_ACCORDION = 'twoStepInstallDialogScopesAccordion';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION_GROUP = 'twoStepInstallDialogDataManagementAccordionGroup';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION = 'twoStepInstallDialogDataManagementAccordion';
export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_ANALYTICS_ACCORDION = 'twoStepInstallDialogAnalyticsAccordion';

// Other subject ids

export const ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_ADMINHUB_LINK = 'twoStepInstallDialogAdminHubLink';